export default __webpack_public_path__ + "dist/heroes3hota/main.min.css";